"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClassroomTypeEnum = void 0;
/** Тип классной комнаты */
var ClassroomTypeEnum;
(function (ClassroomTypeEnum) {
  /** Комната на одного для индивидуальных занятий */
  ClassroomTypeEnum[ClassroomTypeEnum["individual"] = 1] = "individual";
  /** Групповая комната */
  ClassroomTypeEnum[ClassroomTypeEnum["group"] = 10] = "group";
  /** Комната для записавшихся на занятие через услуги преподавателя */
  ClassroomTypeEnum[ClassroomTypeEnum["user_service_contract"] = 100] = "user_service_contract";
})(ClassroomTypeEnum = exports.ClassroomTypeEnum || (exports.ClassroomTypeEnum = {}));
